import { useRef, useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import axios from 'axios';
import qs from 'qs';
import { ToastContainer, toast } from "react-toastify";
import NavbarAuth from '../components/NavbarAuth';
import Footer from '../components/Footer';


const BVNVerification = () => {

    const [accessToken, setAccessToken] = useState("")

    const verifyResults = (verificationId) => {
        const username = '654e61e419e1f9001cb85ff6';
        const password = 'CIO5KWKMU2TI5WMJMNDVRGVDH3LVEFZA';

        const credentials = btoa(`${username}:${password}`);
        const authHeader = `Basic ${credentials}`;
        console.log(credentials)

        const apiUrl = 'https://api.getmati.com/oauth'; // Replace with your API endpoint
        const verificationUrl = 'https://api.getmati.com/v2/verifications/'

        const data = {
            grant_type: 'client_credentials',
            username: username,
            password: password,
        };

        axios.post(apiUrl, qs.stringify(data), {
            headers: {
                'Authorization': authHeader,
                'Content-Type': 'application/x-www-form-urlencoded',
                // Add other headers as needed
            },
        })
            .then(response => {
                // Handle the response
                console.log(response.data.access_token);
                setAccessToken(response.data.access_token)
                const rToken = response.data.access_token

                //make second axios request to verification endpoint.
                axios.get(verificationUrl + verificationId, {
                    headers: {
                        'Authorization': `Bearer ${rToken}`,
                        'Content-Type': 'application/json',
                        // Add other headers as needed
                    },
                })
                    .then(response => {
                        // Handle the response
                        console.log(response.data.steps);
                        // console.log(response.data.hasProblem)
                        // const userData = response.data.steps[0].data
                        // console.log(userData)  
                        const vStatus = response.data.hasProblem

                        if (vStatus === true) {
                            toast.error("Your BVN Verification Failed. Please Make sure the BVN number and details are correct and try again", {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
                        }
                        else if (vStatus === false) {
                            toast.success("Your BVN Verification was successful.", {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });

                            //get user data and save to session storage.
                               
                        }
                    })
                    .catch(error => {
                        // Handle errors
                        console.error('Error:', error);
                    })
                    .finally(() => {
                        console.log("verification completed")
                    })
            })
            .catch(error => {
                // Handle errors
                console.error('Error:', error);
            })
            .finally(() => {
                console.log("token aquired")
            });
    }

    // useEffect(() => {
    //     verifyResults('6555ec50b7b782001c0ac56e')

    // },[]);




    const button = useRef(null);
    const [clientid] = useState('654e61e419e1f9001cb85ff6');
    const [flowid] = useState('6554d20a1fc59f001c19c9be');


    useEffect(() => {
        if (button.current) {
            button.current.addEventListener('metamap:loaded', ({ detail }) => console.log('[METAMAP] Loaded', detail));
            button.current.addEventListener('metamap:userStartedSdk', ({ detail }) => console.log('[METAMAP] User started verification', detail));

            // Handle event when user finished verification
            button.current.addEventListener('metamap:userFinishedSdk', ({ detail }) => {
                console.log('[METAMAP] User finished verification', detail)
                console.log(detail)
                verifyResults(detail.verificationId)
            });

            // Handle event when user exits verification
            button.current.addEventListener('metamap:exitedSdk', ({ detail }) => {
                console.log('[METAMAP] User exited verification', detail)
                console.log(detail)
                // verifyResults(detail.verificationId)
            });
        }
    }, [button]);

    return (
        <>
            <div className="bg-silver-gradient" style={{ minHeight: "100vh" }}>
                <NavbarAuth />
                <br /><br /><br /><br />
                <section>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-xs-12 col-md-3 col-lg-4"></div>
                            <div className="col-xs-12 col-md-6 col-lg-4">
                                <center className="mt-5">
                                </center>
                                <div className="card p-3 shadow">
                                    <h6 className="bold">BVN Verification</h6>
                                    <p className="text-small text-muted">Verify your BVN to experience a world of safe and secure transactions.</p>
                                    <metamap-button
                                        ref={button}
                                        clientid={clientid}
                                        flowid={flowid}
                                        className="btn-custom"
                                    >
                                    </metamap-button>
                                    <div className="p-3 bg-silver-gradient mt-3" style={{ fontSize: "11px" }}>
                                        Your BVN and verification details are kept secure and confidential. We prioritize robust data protection and will not share your information.
                                    </div>

                                </div>
                                <Link to="/">
                                    <button className="btn-custom w-100 mt-2">Cancel</button>
                                </Link>
                            </div>
                            <div className="col-xs-12 col-md-3 col-lg-4"></div>
                        </div>
                        {/* <br/><br/><br/><br/> */}
                    </div>

                </section>

            </div>
            <Footer />
        </>
    )
}

export default BVNVerification
